import { jsx as _jsx } from "react/jsx-runtime";
import { useIntrinsicVideoElementSize, Video as VideoRoot, } from '@streamr/tv-ui';
import { useEffect, useState } from 'react';
import { MediaService } from '../services/media/MediaService';
import { VideoPropertiesService } from '../services/videoProperties/VideoPropertiesService';
export function Video() {
    const { mediaStream, isUserFacingVideo } = MediaService.getOutput().useMediaStreamData();
    const [videoElement, setVideoElement] = useState(null);
    const videoSize = useIntrinsicVideoElementSize(videoElement ?? undefined);
    const videoType = videoElement?.srcObject instanceof MediaStream &&
        videoElement.srcObject.getVideoTracks()[0]?.isScreenShare
        ? 'screen'
        : 'camera';
    useEffect(() => {
        VideoPropertiesService.getNotificationInterface().notifyVideoPropertiesChanged({
            width: videoSize.videoWidth,
            height: videoSize.videoHeight,
            rotation: 0,
            type: videoType,
        });
    }, [videoSize, videoType]);
    return (_jsx(VideoRoot, { autoPlay: true, playsInline: true, muted: true, srcObject: mediaStream, mirror: isUserFacingVideo, fit: "contain", innerRef: setVideoElement }));
}
